export const SELECT_OPTIONS = [
    'Select',
    'Pending',
    'Withdrawn-Entity Request',
    'Denied-Other',
    'Denied-Eligibility',
    'Denied-Questionable Business Practices',
    'Denied-Conflict of Interest',
    'Denied-Unable to Satisfy Program Requirements',
    'Registered',
    'Active',
    'Denied-Failed Training',
    'Deregistered',
    'Deregistered-Misconduct',
    'Deregistered-Failed to renew',
    'Incomplete'
];

export const ORGANIZATION_TYPE_OPTIONS = [
    'Select',
    'Private Partnership',
    'School',
    'Community Clinic',
    'Faith-based organization',
    'Public Partnership',
    'Community-Based organization'
];

export  const LANGUAGE_OPTIONS = [
    'Select',
    'Arabic',
    'Armenian',
    'Cantonese',
    'English',
    'Farsi',
    'Hmong',
    'Japanese',
    'Khmer/Cambodian',
    'Korean',
    'Lao',
    'Mandarin',
    'Russian',
    'Spanish',
    'Tagalog',
    'Vietnamese'
];

export const BROKER_CERTICIATION_STATUS = [
    'Select',
    'Pending',
    'Incomplete',
    'Withdrawn',
    'Eligible',
    'Certified',
    'Denied',
    'Terminated-Vested',
    'Terminated-For-Cause',
    'Deceased',
    'Suspended'
];

export const FORM_CONSUMER_CONFIG = [
    { 
        stateName: 'phoneNumber',
        type: 'text'
    },
    { 
        stateName: 'firstName',
        type: 'text'
    },
    { 
        stateName: 'lastName',
        type: 'text'
    },
    { 
        stateName: 'ssn',
        type: 'text' 
    },
    { 
        stateName: 'dateOfBirth',
        type: 'text'
    },
    { 
        stateName: 'memberGuid',
        type: 'text'
    },
    { 
        stateName: 'externalCaseId',
        type: 'text'
    }
];

export const FORM_BROKER_CONFIG = [
    { 
        stateName: 'firstName',
        type: 'text'
    },
    { 
        stateName: 'lastName',
        type: 'text' 
    },
    { 
        stateName: 'contactNumber',
        type: 'text',
        maxLength: 10
    },
    { 
        stateName: 'licenseNumber',
        type: 'text'
    },
    { 
        stateName: 'businessName',
        type: 'text'
    },
    { 
        stateName: 'certificationStatus',
        type: 'dropdown',
        dropdownValues: BROKER_CERTICIATION_STATUS
    }
];


export const FORM_ASSISTER_CONFIG = [
    {
        stateName: 'contactNumber',
        type: 'text'
    },
    {
        stateName: 'firstName',
        type: 'text',
        i18n: 'assisterFName'    
    },
    {
        stateName: 'lastName',
        type: 'text',
        i18n: 'assisterLName'
    },
    { 
        stateName: 'entityName',
        type: 'text'    
    },
    {
        stateName: 'status',
        type: 'checkbox',
        checkboxValues: ['Active', 'Inactive']
    },
    {
        stateName: 'certificationStatus',
        type: 'dropdown',
        dropdownValues: SELECT_OPTIONS
    },
    {
        stateName: 'header.registrationDate',
        type: 'header',
        className: 'font-weight-bold'
    },
    { 
        stateName: 'fromDate',
        type: 'date'
    },
    { 
        stateName: 'toDate',
        type: 'date' 

    }
];

export const ENTITY_TYPES = {
    ASSISTER: 'ASSISTER',
    BROKER: 'BROKER',
    CONSUMER: 'CONSUMER'
};

export const BROKER_SORT_BY_TYPES = {
    CONTACT_NAME: 'CONTACT_NAME',
    COMPANY_NAME: 'companyName',
    LICENSE_NUMBER: 'licenseNumber',
    CERTIFICATION_STATUS: 'certificationStatus'
};

export const ASSISTER_SORT_BY_TYPES = {
    FIRST_NAME: 'FIRST_NAME',
    ENTITY_NAME: 'ENTITY_NAME',
    RECERTIFICATION_DATE: 'RECERTIFICATION_DATE',
    STATUS: 'STATUS',
    CERTIFICATION_STATUS: 'CERTIFICATION_STATUS',
};